const typeDefs = `
    type DefaultType {
        defaultProp: String
    }
`;

const typeExtensions = `
    type DefaultExtension {
        defaultProp: String
    }

    extend type SGContent {
        partner: PartnerAccount
        thematic: PartnerAccount
    }

    extend type SGDocument {
        partner: PartnerAccount
        thematic: PartnerAccount
    }

    extend input ContentSearchParams {
        maxDate: Long
        minDate: Long
    }

    extend input DocumentSearchParams {
        maxDate: Long
        minDate: Long
    }
`;

export { typeDefs, typeExtensions };
